import React from 'react';
import root from 'window-or-global';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Header, LoadIndicator, Login, Footer} from '../../components';
import styles from './Payout.pcss';
import {RedirectWithParams, getMessage} from 'epic-diesel-common';
import payoutActions from '../../actions/payout.actions';
import Url from '../../constants/Url';
import Select from 'epic-diesel-form/src/components/form/Select';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import {Message} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import Icon from 'epic-diesel-common/src/components/icon/Icon';
import {
    Table,
    TableCell,
    TableTitle,
    TableHead,
    TableRow,
    TableBody
} from '@epic-ui/epic/src/index';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    userState: state.get('user').toJS(),
    settingsState: state.get('settings').toJS(),
    influencerState: state.get('influencer').toJS(),
    configState: state.get('config').toJS(),
    payoutState: state.get('payout').toJS()
});

const mapDispatchToProps = dispatch => ({
    getPayoutPeriods: () => {
        dispatch(payoutActions.getPayoutOptions());
    },
    getPayout: date => {
        dispatch(payoutActions.getPayoutReport(date));
    }
});

class Payout extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        updatePayout: PropTypes.func,
        influencerState: PropTypes.object,
        userState: PropTypes.object,
        configState: PropTypes.object,
        payoutState: PropTypes.object,
        getPayoutPeriods: PropTypes.func,
        getPayout: PropTypes.func
    };

    state = {
        currentPeriod: ''
    };

    componentDidMount() {
        const {isLoggedIn} = this.props.userState.accountInfo;
        if (isLoggedIn) {
            this.props.getPayoutPeriods();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {payoutState} = nextProps;

        if (payoutState.date && payoutState.date !== this.state.currentPeriod) {
            this.setState({currentPeriod: payoutState.date});

            this.props.getPayout({payoutPeriod: payoutState.date});
        }
    }

    changeReportPeriod = (entry, value) => {
        this.props.getPayout({payoutPeriod: value});
    };

    downloadPayoutReport = () => {
        const {payoutState} = this.props;
        root.open(`${Url().DOWNLOAD_PAYOUT_REPORT}?payoutPeriod=${payoutState.date}`);
    };

    render() {
        const {influencerState, userState, messages, configState, payoutState} = this.props;

        const {affiliateAccount} = influencerState;
        const {accountInfo} = userState;
        const {epicFooter} = configState;

        // If the affiliate has not been approved, redirect to home page
        if (!affiliateAccount || affiliateAccount.status !== 'ACTIVE') {
            return <RedirectWithParams to="/affiliate/overview" />;
        }

        const dateOptions = [];

        if (payoutState.dateOptions) {
            payoutState.dateOptions.forEach(entry => {
                dateOptions.push({
                    value: entry,
                    label: entry
                });
            });
        }

        const payoutReportTitle = getMessage(
            messages,
            'label.affiliate.form.payoutReport.payoutReportTitle'
        );

        return (
            <div>
                <Header
                    messages={messages}
                    headerClass={styles.header}
                    affiliateAccount={affiliateAccount}
                    accountInfo={accountInfo}
                    configState={configState}
                />
                <div className={styles.container}>
                    <Login isLoggedIn={accountInfo.isLoggedIn}>
                        <LoadIndicator isLoading={false} messages={messages}>
                            <TableTitle>
                                <span>
                                    {payoutReportTitle}
                                    {payoutState.date ? `: ${payoutState.date}` : ''}
                                </span>
                                {payoutState.data && payoutState.data.details && (
                                    <button
                                        type="button"
                                        className={styles.downloadButton}
                                        onClick={this.downloadPayoutReport}>
                                        <Icon size={sizes.XXSMALL} icon={svgs.DOWNLOAD} />
                                    </button>
                                )}
                            </TableTitle>

                            {payoutState.date !== undefined && (
                                <>
                                    <FormsyForm>
                                        <div className={styles.viewReport}>
                                            <Message
                                                code="label.affiliate.form.payoutReport.month"
                                                className={styles.viewReportText}
                                            />
                                            <Select
                                                name="month"
                                                value={payoutState.date}
                                                onChange={this.changeReportPeriod}
                                                options={dateOptions}
                                            />
                                        </div>
                                    </FormsyForm>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Message
                                                        code="label.affiliate.form.payoutReport.product"
                                                        className={styles.viewReportText}
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Message
                                                        code="label.affiliate.form.payoutReport.revenueEarned"
                                                        className={styles.viewReportText}
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Message
                                                        code="label.affiliate.form.payoutReport.revenue"
                                                        className={styles.viewReportText}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {!payoutState.loadingData &&
                                                payoutState.data &&
                                                payoutState.data.details &&
                                                payoutState.data.details.map(row => (
                                                    <TableRow key={row.id}>
                                                        <TableCell>{row.productName}</TableCell>
                                                        <TableCell align="right">
                                                            <div className={styles.viewReportValue}>
                                                                $
                                                                {(
                                                                    row.revenueEarnedThisPeriod /
                                                                    100.0
                                                                ).toFixed(2)}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <div className={styles.viewReportValue}>
                                                                $
                                                                {(
                                                                    row.revenueEarnedYearToDate /
                                                                    100.0
                                                                ).toFixed(2)}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </>
                            )}

                            {payoutState.date === undefined && (
                                <div className={styles.noPayouts}>
                                    <Message code="label.affiliate.form.payoutReport.noPayouts" />
                                </div>
                            )}
                        </LoadIndicator>
                    </Login>
                </div>
                <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Payout);
